import '.ac{flex-shrink:0;}.ssr-plugin'
import '.aw{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.av{height:100%;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.cu{background-color:transparent;}.ssr-plugin'
import '.cv{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.be{position:sticky;}.ssr-plugin'
import '.cw{top:4rem;}.ssr-plugin'
import '.cx{z-index:7;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.cy{padding-bottom:1rem;}.ssr-plugin'
import '.cz{margin-bottom:1rem;}.ssr-plugin'
import '.d0{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bn{left:0px;}.ssr-plugin'
import '.bo{right:0px;}.ssr-plugin'
import '.bp{bottom:0px;}.ssr-plugin'
import '.cr{z-index:9999;}.ssr-plugin'
import '.cs{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bd{justify-content:flex-end;}.ssr-plugin'
import '.ax{flex:1;}.ssr-plugin'
import '.by{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ac aw l av c4 cu cv"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e r"
    >
      <div className="be cw cx v cy cz d0 d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bf bn bo bp cr v cs d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aw d bd d0"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ax by">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
